import { useContext } from "react";
import { FeaturesContext } from "../contexts";

const useFeatures = () => {
  return useContext(FeaturesContext);
};

export default useFeatures;
